/**
 * Labhya single-select filtering — Shopify-safe version.
 * Keeps Shopify's own collection routes and filter forms intact.
 * One option can be active inside each attribute group; different groups may combine.
 */
(() => {
  const GROUPS = {
    material: ['cotton','nylon','rayon','viscose','linen','silk','chiffon','georgette','mul-cotton','polyester'],
    occasion: ['workwear','festive','casual-outing','day-event','party','daily-wear','wedding'],
    pattern: ['floral','geometric','solid','printed','paisley','striped','abstract','kalamkari'],
    sleeve: ['sleeveless','cap','short','elbow','three-quarter','full-sleeve'],
    neckline: ['round','v','square','mandarin','shirt-collar','boat'],
    'fit-silhouette': ['straight','a-line','anarkali','regular'],
    features: ['pockets','side-slits']
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();

  // Native Shopify facets: radio-like behavior inside each list facet.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox' || !input.checked) return;
    const group = input.closest('facet-inputs-component');
    if (!group) return;
    group.querySelectorAll('input[type="checkbox"]').forEach((other) => {
      if (other !== input && other.checked) other.checked = false;
    });
  }, true);



  // Make the radio marker itself clickable while preserving Shopify's canonical tag link.
  document.addEventListener('click', (event) => {
    const marker = event.target instanceof Element ? event.target.closest('.labhya-smart-filter__check') : null;
    if (!marker) return;
    const item = marker.closest('.labhya-smart-filter__item');
    const anchor = item ? item.querySelector('a') : null;
    if (!(anchor instanceof HTMLAnchorElement)) return;
    event.preventDefault();
    anchor.click();
  });

  // Custom tag facets: use Shopify-generated href as the starting point, then remove
  // any sibling value from the same group. This preserves the collection handle,
  // other active groups, sort query, locale and market prefixes from Shopify's URL.
  document.addEventListener('click', (event) => {
    const anchor = event.target instanceof Element ? event.target.closest('.labhya-smart-filter__item a') : null;
    if (!(anchor instanceof HTMLAnchorElement)) return;
    const item = anchor.closest('.labhya-smart-filter__item');
    const root = anchor.closest('.labhya-smart-filters');
    if (!item || !root) return;

    const groupKey = normalize(item.dataset.labhyaFilterGroup);
    const selectedValue = normalize(item.dataset.labhyaFilterValue);
    const sameGroup = GROUPS[groupKey];
    if (!sameGroup || !selectedValue) return;

    const target = new URL(anchor.href, window.location.origin);
    const collectionUrl = root.dataset.labhyaCollectionUrl || '';
    if (!collectionUrl) return;

    // Preserve locale/market prefix by locating the canonical collection URL in pathname.
    const collectionIndex = target.pathname.indexOf(collectionUrl);
    if (collectionIndex < 0) return;
    const prefix = target.pathname.slice(0, collectionIndex);
    const base = prefix + collectionUrl.replace(/\/$/, '');
    const tail = target.pathname.slice((prefix + collectionUrl).length).replace(/^\/+/, '');
    let tags = tail ? decodeURIComponent(tail).split('+').filter(Boolean) : [];

    const active = item.classList.contains('is-active');
    tags = tags.filter((tag) => !sameGroup.includes(normalize(tag)));
    if (!active) tags.push(selectedValue);

    // De-duplicate without altering the order of other active tag groups.
    const seen = new Set();
    tags = tags.filter((tag) => {
      const key = normalize(tag);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    target.pathname = base + (tags.length ? '/' + tags.join('+') : '');
    event.preventDefault();
    window.location.assign(target.toString());
  });

  // Display-only brand cleanup for legacy collection descriptions. This avoids placing
  // filtered Liquid inside JSON template settings, which can invalidate Shopify resources.
  const cleanCollectionBrandCopy = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const firstSection = document.querySelector('#MainContent > :first-child');
    if (!firstSection) return;
    const walker = document.createTreeWalker(firstSection, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!node.nodeValue) return;
      node.nodeValue = node.nodeValue
        .replace(/Sparrows Apparels/gi, 'Labhya')
        .replace(/Sparrows/gi, 'Labhya');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanCollectionBrandCopy, { once: true });
  else cleanCollectionBrandCopy();
})();
